export default "__VITE_ASSET__sOkJlJb2__"